import { State } from '@progress/kendo-data-query';
import { formatDate } from '@progress/kendo-intl';
import { GridColumn } from 'src/components/GridWrapper';
import { IFilters } from 'src/types/PostBody';

interface FilterObject {
  filters: IFilters[];
}

const dateOperators: Record<string, string> = {
  eq: 'equalsDate',
  neq: 'notEqualsDate',
  gte: 'greaterThanEqualsDate',
  gt: 'greaterThanDate',
  lt: 'lessThanDate',
  lte: 'lessThanEqualsDate',
};

export const modifyFilters = (obj: any, dateField?: string[], shouldStringify = true) => {
  let filtersArr: any = [];
  if (obj) {
    obj?.filters?.forEach((filterObj: FilterObject) => {
      let filterOption: any = { ...filterObj?.filters?.[0] };

      // Trim string filter values
      if (filterOption?.value !== undefined && typeof filterOption.value === 'string') {
        filterOption.value = filterOption.value.trim();
      }

      if (dateField?.includes(filterOption?.field)) {
        const oldDate = new Date(filterOption?.value as string);
        const newDate = formatDate(oldDate, 's');
        filterOption.dateTimeValue = newDate;
        filterOption.operator = dateOperators[filterOption?.operator] || filterOption?.operator;
      }
      filtersArr?.push(filterOption);
    });
  }
  if (shouldStringify) {
    filtersArr?.forEach((filter: IFilters) => (filter.value = filter?.value?.toString()));
  }
  return filtersArr;
};

const formatStringFieldsIsNull = (filters: IFilters[], stringFields: string[]) =>
  filters.map((filter) => {
    if (stringFields.includes(filter.field)) {
      if (filter.operator === 'isnull') {
        filter.operator = 'isnullorempty';
      }
      if (filter.operator === 'isnotnull') {
        filter.operator = 'notisnullorempty';
      }
    }

    return filter;
  });

export const modifyRequest = (
  request: State,
  dateArr?: string[],
  columns?: GridColumn<any>[],
  strFields?: string[],
  shouldStringify = true
) => {
  const { dateFields, stringFields } = (columns || []).reduce<{
    dateFields: string[];
    stringFields: string[];
  }>(
    (acc, column) => {
      if (column.filter === 'text') {
        acc.stringFields.push(column.field as string);
      }
      if (column.filter === 'date') {
        acc.dateFields.push(column.field as string);
      }
      return acc;
    },
    { dateFields: [], stringFields: [] }
  );

  const { skip = 0, take = 0, sort = [], filter = [] } = request || {};
  return {
    skip,
    take,
    sort: sort || [],
    filters: formatStringFieldsIsNull(
      modifyFilters(filter, dateArr || dateFields, shouldStringify),
      stringFields.length ? stringFields : strFields || []
    ),
  };
};
